/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt, { onAccessTokenFetched } from '../../http/requests/auth/jwt/index.js';
import app from '../../http/requests/app/index.js';

import router from '@/router';

export default {
    // JWT
    loginJWT ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            jwt.loginWithToken(payload.token)
                .then(response => {

                    // If there's user data in response
                    if (response.data.data.user) {
                        // Set accessToken
                        localStorage.setItem('accessToken', response.data.data.access_token);
                        localStorage.setItem('refreshToken', response.data.data.refresh_token);
                        localStorage.setItem('accessRules', JSON.stringify(response.data.data.permissions));

                        // Update user details
                        commit('UPDATE_USER_INFO', response.data.data.user, { root: true });
                        commit('UPDATE_USER_ACCESS', response.data.data.permissions, { root: true });

                        // Set bearer token in axios
                        commit('SET_BEARER', response.data.data.access_token);

                        // Navigate User to homepage
                        router.push(router.currentRoute.query.to || localStorage.getItem('returnUrl') || '/');

                        localStorage.removeItem('returnUrl');

                        // eslint-disable-next-line no-undef
                        gtag('event', 'login', {
                            method: 'Office365',
                        });

                        resolve(response);
                    } else {
                        reject({ message: 'Wrong Email or Password' });
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    registerUserJWT ({ commit }, payload) {
        const {
            displayName,
            email,
            password,
            confirmPassword,
        } = payload.userDetails;

        return new Promise((resolve, reject) => {

            // Check confirm password
            if (password !== confirmPassword) {
                reject({ message: 'Password doesn\'t match. Please try again.' });
            }

            jwt.registerUser(displayName, email, password)
                .then(response => {
                    // Redirect User
                    router.push(router.currentRoute.query.to || '/');

                    // Update data in localStorage
                    localStorage.setItem('accessToken', response.data.accessToken);
                    commit('UPDATE_USER_INFO', response.data.userData, { root: true });

                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    logoutJWT ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            jwt.logoutWithToken(payload.token)
                .then(response => {
                    if (response.data.success) {
                        resolve(response);
                    } else {
                        reject({ message: response.data.message });
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    getUserInfo ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            app.userInfo()
                .then(response => {
                    if (response.data.success) {
                        resolve(response);
                    } else {
                        reject({ message: response.data.message });
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    fetchAccessToken ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            jwt.refreshToken(payload.token).then(response => {
                // If there's user data in response
                if (response.data.data.user) {
                    // Set accessToken
                    localStorage.setItem('accessToken', response.data.data.access_token);
                    localStorage.setItem('refreshToken', response.data.data.refresh_token);
                    localStorage.setItem('accessRules', JSON.stringify(response.data.data.permissions));

                    // Update user details
                    commit('UPDATE_USER_INFO', response.data.data.user, { root: true });
                    commit('UPDATE_USER_ACCESS', response.data.data.permissions, { root: true });

                    // Set bearer token in axios
                    commit('SET_BEARER', response.data.data.access_token);

                    resolve(response);
                } else {
                    reject({ message: 'Failed to refresh token' });
                }
            }).catch(error => {
                reject(error);
            });
        });
    },
    loginWithZohoDesk ({ commit }, payload) {
        return new Promise((resolve, reject) => {
            jwt.loginWithZohoDeskUserEmail(payload.email).then(response => {
                // If there's user data in response
                if (response.data.data.user) {
                    // Set accessToken
                    localStorage.setItem('accessToken', response.data.data.access_token);
                    localStorage.setItem('refreshToken', response.data.data.refresh_token);
                    localStorage.setItem('accessRules', JSON.stringify(response.data.data.permissions));

                    // Update user details
                    commit('UPDATE_USER_INFO', response.data.data.user, { root: true });
                    commit('UPDATE_USER_ACCESS', response.data.data.permissions, { root: true });

                    // Set bearer token in axios
                    commit('SET_BEARER', response.data.data.access_token);

                    onAccessTokenFetched(response.data.data.access_token);

                    resolve(response);
                } else {
                    reject({ message: 'Failed to login from Zoho Desk' });
                }
            }).catch(error => {
                reject(error);
            });
        });
    },
    getUsersList({commit}, payload) {
        return app.usersList();
    },
    impersonate ({ commit }, payload) {
        return app.impersonate(payload.id);
    },
    stopImpersonate () {
        return app.stopImpersonate();
    }
};
